import React, { Component } from 'react';
import { PaddedSection, Button } from '../../atoms';
import Markdown from 'markdown-to-jsx';
import ContentConverter from '../../../utils/contentConverter';
import { Link } from 'react-router-dom';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {Array} content
 * @prop {String} heading
 * @prop {String} subheading
 * @prop {String} [className]
 * @prop {String} [href]
 *
 * @augments {Component<Props>}
 */
export default class New extends Component {
	/**
	 * @param {String} content
	 */
	getContent = (content) =>
		new ContentConverter(content).convertLinks().nlToBr().getHtml();

	handleClik = (href) => {
		const anchorRef = document.querySelector(href);
		if (!anchorRef) return;
		// @ts-ignore
		const top = anchorRef.parentElement.offsetTop + anchorRef.offsetTop;
		window.location.hash = href;
		requestAnimationFrame(() => window.scrollTo({ behavior: 'smooth', top }));
	}

	render () {
		const { buttonLabel, content, heading, href, subheading } = this.props;
		return (
			<PaddedSection className='New'>
				<div className='New-image' />
				<div className='New-content'>
					{subheading ? <h2>{subheading}</h2> : null}
					<h1>{heading}</h1>
					{content.map((item) => (
						<p key={item}>
							<Markdown
								options={{
									overrides: {
										Link: {
											component: Link,
										},
									},
								}}
							>
								{this.getContent(item)}
							</Markdown>
						</p>
					))}
					<Button className='New-button' onClick={() => {
						this.handleClik(href);
					}}>
						<span>{buttonLabel}</span>
					</Button>
				</div>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/New/New.js